// 2024-11-08 k_nagayama submit追加
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useSubmitFiles from '../hooks/useSubmitFiles';
import ListItemUserFiles from '../components/ListItemUserFiles';
import { PiCircleNotch } from 'react-icons/pi';
import ListItemCollapse2 from '../components/ListItemCollapse2';

const AdminSubmitFilesPage: React.FC = () => {
  const { t } = useTranslation();

  const [users, setUsers] = useState<{ userId: string, username: string }[]>([]);
  const [isLoading, setLoading] = useState(true);
  const [searchUser, setSearchUser] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const {
    getSubmitedUserList,
  } = useSubmitFiles();

  useEffect(() => {
    (async () => {
      setLoading(true);
      setUsers((await getSubmitedUserList()).data)
      setLoading(false);
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const filteredUsers = useMemo(() => {
    if (!searchUser.trim()) return users;
    const keyword = searchUser.trim().toLowerCase();
    return users.filter((u) => u.username.toLowerCase().includes(keyword));
  }, [users, searchUser]);

  const dateFromDate = useMemo(() => dateFrom ? new Date(dateFrom) : undefined, [dateFrom]);
  const dateToDate = useMemo(() => {
    if (!dateTo) return undefined;
    const d = new Date(dateTo);
    d.setHours(23, 59, 59, 999);
    return d;
  }, [dateTo]);

  return (
    <>
      <div className="flex h-full justify-center">
        <div className="w-2/3">
          <div className="size-full pt-8">
            <div className="flex items-end justify-between">
              <div className="flex items-center gap-2">
                <div className="text-xl font-bold">{t('submitFiles.label.myFiles')}</div>
              </div>
            </div>
            <div className="mt-2 border-b border-gray"></div>

            {/* 検索エリア */}
            <div className="mt-3 mb-2 flex flex-wrap items-end gap-3">
              <div className="flex flex-col gap-1">
                <label className="text-xs text-dark-gray">{t('submitFiles.label.searchUser')}</label>
                <input
                  type="text"
                  value={searchUser}
                  onChange={(e) => setSearchUser(e.target.value)}
                  placeholder={t('submitFiles.label.searchPlaceholder')}
                  className="rounded border border-gray px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-aws-logo-color"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs text-dark-gray">{t('submitFiles.label.searchDateFrom')}</label>
                <input
                  type="date"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                  className="rounded border border-gray px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-aws-logo-color"
                />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-xs text-dark-gray">{t('submitFiles.label.searchDateTo')}</label>
                <input
                  type="date"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                  className="rounded border border-gray px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-aws-logo-color"
                />
              </div>
            </div>

            <div className="h-4/5 overflow-x-hidden overflow-y-scroll border-b border-gray pr-1 scrollbar-thin scrollbar-thumb-aws-font-color/20 ">
              {filteredUsers?.length === 0 && (
                <>
                  {isLoading ? (
                    <div className="flex flex-col items-center p-4">
                      <div className="animate-spin">
                        <PiCircleNotch size={100} />
                      </div>
                    </div>
                  ) : (
                    <div className="flex size-full items-center justify-center italic text-dark-gray">
                      {t('submitFiles.label.noFiles')}
                    </div>
                  )}
                </>
              )}
              {filteredUsers?.map((user) => (
                <>
                  <ListItemCollapse2
                    title={user.username}>
                    <ListItemUserFiles
                      userId={user.userId}
                      onClick={() => { }}
                      dateFrom={dateFromDate}
                      dateTo={dateToDate}
                    >
                    </ListItemUserFiles>
                  </ListItemCollapse2>
                </>
              ))}
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default AdminSubmitFilesPage;
// 2024-11-08 k_nagayama submit追加 ここまで
